import Icons, { IconsProps } from '../Icons';

// https://www.zhangxinxu.com/sp/svgo/

export default function (props: IconsProps) {
  return (
    <Icons {...props}>
      <path
        d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0028 12 0.00135937 12 0C18.6274 0 24 5.37262 24 12Z"
        fill="#0052B4"
      />
      <path d="M11.9679 12H12V11.9679L11.9679 12Z" fill="#F0F0F0" />
      <path
        d="M12 6.2609V0L11.998 4.6875e-05C5.37152 0.001125 0 5.37323 0 12L6.26086 12V8.47444L9.78642 12L11.9679 12L12 11.9679L12 9.78651L8.47444 6.2609H12Z"
        fill="#F0F0F0"
      />
      <path
        d="M6.071 1.56521C4.19217 2.63591 2.63588 4.1922 1.56519 6.07102V12H4.69564V4.69566H12V1.56521H6.071Z"
        fill="#D80027"
      />
      <path d="M12 10.5243L7.73655 6.26096H6.26088L11.9999 12L12 12L12 10.5243Z" fill="#D80027" />
      <path
        d="M7.23724 14.087L7.89584 15.4641L9.38304 15.1203L8.71704 16.4939L9.91301 17.4423L8.42393 17.7779L8.4281 19.3043L7.23724 18.3494L6.04643 19.3043L6.0506 17.7779L4.56148 17.4423L5.75749 16.4939L5.0914 15.1203L6.5787 15.4641L7.23724 14.087ZM17.9664 16.6957L18.2957 17.3842L19.0393 17.2123L18.7063 17.8991L19.3043 18.3733L18.5598 18.5411L18.5618 19.3043L17.9664 18.8268L17.371 19.3043L17.3731 18.5411L16.6286 18.3733L17.2265 17.8991L16.8935 17.2123L17.6371 17.3842L17.9664 16.6957ZM14.9031 9.39131L15.2323 10.0799L15.976 9.90797L15.643 10.5947L16.2409 11.069L15.4964 11.2368L15.4984 12L14.9031 11.5225L14.3077 12L14.3097 11.2368L13.5652 11.069L14.1632 10.5947L13.8302 9.90797L14.5738 10.0799L14.9031 9.39131ZM17.9664 5.21737L18.2957 5.90597L19.0393 5.73408L18.7063 6.42084L19.3043 6.89503L18.5598 7.06289L18.5618 7.82611L17.9664 7.34859L17.371 7.82611L17.3731 7.06289L16.6286 6.89503L17.2265 6.42084L16.8935 5.73408L17.6371 5.90597L17.9664 5.21737ZM20.6422 8.34783L20.9715 9.03642L21.7151 8.86448L21.3821 9.55125L21.9801 10.0255L21.2355 10.1933L21.2376 10.9565L20.6422 10.479L20.0468 10.9565L20.0488 10.1933L19.3043 10.0255L19.9023 9.55125L19.5693 8.86448L20.3129 9.03642L20.6422 8.34783ZM18.7289 12L18.9879 12.7972H19.8261L19.1479 13.2899L19.407 14.087L18.7289 13.5943L18.0508 14.087L18.3098 13.2899L17.6317 12.7972H18.4699L18.7289 12Z"
        fill="#F0F0F0"
      />
    </Icons>
  );
}
